<template>
  <div
    v-if="tickets.length"
    class="overflow-x-auto"
  >
    <table class="TicketsTableEditable StylizedTable">
      <thead>
        <tr>
          <td class="w-sub-pcnt">
            #
          </td>
          <td class="w-2/3">
            <v-icon type="odometer"/>
            <span>Пробег</span>
          </td>
          <td class="w-sub-pcnt">
            <div class="xsm:hidden">Изтрий</div>
            <div class="sm:hidden">Изтр.</div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(ticket, index) in tickets"
          :key="ticket.id"
        >
          <td>{{ index + 1 }}</td>
          <td class="text-right w-48">
            <form-field
              :validator="validator ? validator.$each[index].mileage: undefined"
              :space-bottom="false"
              transparent
              name="ticket"
            >
              <mileage-input
                :value="ticket.mileage"
                class="font-segmented text-5xl"
                @input="updateTicketValue(index, $event)"
              />
            </form-field>
          </td>
          <td>
            <v-button
              color="is-red"
              size="xsm"
              icon="bin"
              plain
              class="xsm:p-0 xsm:text-sm"
              @click="removeItem(index)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    Изберете количество билети които да бъдат генерирани.
  </div>
</template>

<script>

/**
 * @module TicketsTableEditable
 */
export default {
  name: 'TicketsTableEditable',
  props: {
    tickets: {
      type: Array,
      default: () => ([])
    },
    validator: {
      type: Object,
      default: null
    }
  },

  methods: {
    updateTicketValue (index, mileage) {
      if (this.validator) {
        this.validator.$each[index].$touch()
      }
      const tickets = this.tickets.slice(0)
      const ticket = tickets[index]

      tickets[index] = {
        ...ticket,
        mileage
      }
      this.$emit('update:tickets', tickets)
    },
    removeItem (index) {
      const tickets = this.tickets.slice(0)
      tickets.splice(index, 1)
      this.$emit('update:tickets', tickets)
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

</style>
